import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/img/logo.png'
import _imports_1 from '../assets/img/title.png'
import _imports_2 from '../assets/img/sub_title.png'
import _imports_3 from '../assets/img/rule_btn.png'
import _imports_4 from '../assets/img/text_01.png'
import _imports_5 from '../assets/img/text_02.png'
import _imports_6 from '../assets/img/text_03.png'
import _imports_7 from '../assets/img/text_04.png'
import _imports_8 from '../assets/img/click_btn.png'


const _hoisted_1 = { class: "page-home" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"logo\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><div class=\"title\"><img src=\"" + _imports_1 + "\" alt=\"\"></div><div class=\"sub-title\"><img src=\"" + _imports_2 + "\" alt=\"\"></div>", 3)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "main" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"text\"><img src=\"" + _imports_4 + "\" alt=\"\"><img src=\"" + _imports_5 + "\" alt=\"\"><img src=\"" + _imports_6 + "\" alt=\"\"><img src=\"" + _imports_7 + "\" alt=\"\"></div>", 1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_20 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "wall" }
const _hoisted_24 = { class: "barrage-list" }
const _hoisted_25 = { class: "barrage-item" }
const _hoisted_26 = { class: "avatar" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "container" }
const _hoisted_29 = { class: "name" }
const _hoisted_30 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Lottery = _resolveComponent("Lottery")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: "rule",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goRule && _ctx.goRule(...args)))
      }, _hoisted_6),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", {
          class: "tips",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goVideoCapture && _ctx.goVideoCapture(...args)))
        }, _hoisted_20),
        _createElementVNode("div", {
          class: "record",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goRecord && _ctx.goRecord(...args)))
        }),
        _createElementVNode("div", {
          class: "click",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goVideoCapture && _ctx.goVideoCapture(...args)))
        }, _hoisted_22)
      ]),
      _createElementVNode("div", _hoisted_23, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (itemList) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemList, (item) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("img", {
                    src: _ctx.defaultUser(item.avatar),
                    alt: ""
                  }, null, 8, _hoisted_27)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(item.nick_name) + "：", 1),
                  (!item.amount && item.content)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        innerHTML: item.content
                      }, null, 8, _hoisted_30))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 256))
          ]))
        }), 256))
      ])
    ], 512), [
      [_vShow, !_ctx.lotteryShow]
    ]),
    (_ctx.lotteryShow)
      ? (_openBlock(), _createBlock(_component_Lottery, {
          key: 0,
          onBack: _cache[4] || (_cache[4] = ($event: any) => (_ctx.lotteryShow = false))
        }))
      : _createCommentVNode("", true)
  ]))
}